import { useNavigate } from 'react-router-dom';
import { DIALOG_CONFIRMATION } from 'shared/constants/modal-constants';
import { TAlertDialog } from 'shared/types/card.interface';

export const useCommonDialog = (path: string): TAlertDialog => {
  const navigate = useNavigate();

  return {
    ...DIALOG_CONFIRMATION,
    сonsentCallback: () => {
      navigate(path);
    },
  };
};
